/**
 * Formattazione date lato server/client coerente (ICU completo su Node 22).
 * `short` per le card, `long` per la testata articolo. Restituisce null se la
 * data è assente, così il chiamante può omettere il nodo <time>.
 */
export const formatDate = (
  value?: string | null,
  opts: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short', year: 'numeric' },
): string | null => (value ? new Date(value).toLocaleDateString('it-IT', opts) : null)

export const DATE_LONG: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }
